import { Flex, Form } from "antd";
import {
  CurrencyOperationCodesField,
  currencyOperationCodesRequiredRule,
  currencyOperationCodesToApiString,
  parseCurrencyOperationCodesFromApi,
} from "components";
import { FORM_VALIDATION_DEBOUNCE } from "constants/form";
import { observer } from "mobx-react-lite";
import { useNotificationContext } from "providers";
import { useState } from "react";

import { useStores } from "stores";
import { CustomButton } from "ui";
import { requestWithNotify } from "utils";

const UPDATE_BID_CARD_DELAY = 2500;

export const CurrencyCodeEditModal = observer(() => {
  const { actionModals, bidCard, user } = useStores();
  const { openNotification } = useNotificationContext();
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();
  const selectedCodes = Form.useWatch("currencyOperationCodes", form) as string[] | undefined;
  const hasSelection = Array.isArray(selectedCodes) && selectedCodes.length > 0;

  const allowCustomCodes = user.roles.isSeniorOperator;
  const contractDirection = bidCard.bid.contract?.direction;

  const editCurrencyCodeHandler = async () => {
    if (!bidCard.bid.id) {
      return;
    }
    setLoading(true);

    try {
      const codes = form.getFieldValue("currencyOperationCodes") as string[];
      const res = await requestWithNotify({
        fetchFn: () =>
          bidCard.updateCurrencyOperationCode(bidCard.bid.id, {
            currencyOperationCode: currencyOperationCodesToApiString(codes ?? []),
          }),
        openNotification,
        successMsg: "Код вида операции изменен",
      });

      if (res.result) {
        await requestWithNotify({
          fetchFn: () => bidCard.updateCardById(bidCard.bid.id),
          openNotification,
          showErrorNotification: false,
          delay: UPDATE_BID_CARD_DELAY,
        });
      }
    } finally {
      setLoading(false);
      handleCancelCurrencyCodeEdit();
    }
  };

  const handleCancelCurrencyCodeEdit = () => {
    actionModals.closeAll();
  };

  const initialCodes = parseCurrencyOperationCodesFromApi(bidCard.bid.currencyOperationCode);

  return (
    <Flex vertical gap="large">
      <Form
        form={form}
        name="editCurrencyCode"
        onFinish={() => editCurrencyCodeHandler()}
        initialValues={{
          currencyOperationCodes: initialCodes,
        }}
      >
        <Flex vertical gap="small">
          <Form.Item
            name="currencyOperationCodes"
            rules={[currencyOperationCodesRequiredRule()]}
            validateDebounce={FORM_VALIDATION_DEBOUNCE}
          >
            <CurrencyOperationCodesField
              allowCustomCodes={allowCustomCodes}
              contractDirection={contractDirection === "IMP" ? "IMP" : "EXP"}
              disabled={loading}
              placeholder="Код вида операции"
            />
          </Form.Item>
        </Flex>

        <Form.Item>
          <Flex gap="large">
            <CustomButton
              htmlType="submit"
              disabled={loading || !hasSelection}
              loading={loading}
              className="full-width"
            >
              Сохранить изменения
            </CustomButton>
            <CustomButton
              htmlType="button"
              disabled={loading}
              loading={loading}
              type="default"
              onClick={handleCancelCurrencyCodeEdit}
              className="full-width"
            >
              Отменить
            </CustomButton>
          </Flex>
        </Form.Item>
      </Form>
    </Flex>
  );
});
